<div class="unauthorized-container">
  <!-- Icon -->
  <i class="fas fa-lock fa-5x" style="color: #d32f2f"></i>

  <h1>Access Denied</h1>
  <p>You are not authorized to view this page.</p>
  <button (click)="navigateToLogin()">Go to Home</button>
</div>
